import { PollRounded } from "@mui/icons-material";
import { Box, Card, Tab, Tabs, Typography } from "@mui/material";
import { PropsWithChildren } from "react";
import { black, greyEnabled, purple, purpleLight } from "../../theme/colors";

const TAB_SUBTITLES = [
  "Manage surveys and view submitted responses.",
  "Manage auto-notification events triggered by survey activity.",
];

interface ChoicesLayoutProps {
  currentTab: number;
  onTabChange: (tab: number) => void;
}

export default function ChoicesLayout({
  children,
  currentTab,
  onTabChange,
}: PropsWithChildren<ChoicesLayoutProps>) {
  return (
    <Box>
      <Box display="flex" alignItems="center" gap={1.5}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 44,
            height: 44,
            borderRadius: 2,
            bgcolor: purpleLight,
            flexShrink: 0,
          }}
        >
          <PollRounded sx={{ color: purple, fontSize: 24 }} />
        </Box>
        <Box>
          <Typography variant="h5" fontWeight={700} color={black}>
            Surveys
          </Typography>
          <Typography variant="body2" color={greyEnabled} mt={0.5}>
            {TAB_SUBTITLES[currentTab]}
          </Typography>
        </Box>
      </Box>

      <Card
        elevation={0}
        sx={{
          display: "flex",
          mt: 2,
          width: "100%",
          minHeight: 600,
          mb: 2,
          borderRadius: 3,
          border: "1px solid #ECECEC",
        }}
      >
        <Box display="flex" flexDirection="column" sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: "1px solid #ECECEC", px: 3, pt: 1 }}>
            <Tabs
              value={currentTab}
              aria-label="choices tabs"
              onChange={(_, value: number) => onTabChange(value)}
              TabIndicatorProps={{
                style: { backgroundColor: purple, height: 3, borderRadius: 3 },
              }}
            >
              <Tab
                label="Survey Responses"
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                  color: greyEnabled,
                  "&.Mui-selected": { color: purple },
                }}
              />
              <Tab
                label="Auto Notification Created Events"
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                  color: greyEnabled,
                  "&.Mui-selected": { color: purple },
                }}
              />
            </Tabs>
          </Box>
          {children}
        </Box>
      </Card>
    </Box>
  );
}
